import { truncateName } from '@/utils';

export const BOT_NAME_MAX = {
	profileMobile: 14,
	profileDesktop: 22,
	switcherMobile: 12,
	switcherDesktop: 18,
	pill: 10,
	ownerMobile: 18,
	ownerDesktop: 26,
	homeRbpTitle: 14,
} as const;

export function getBotDisplayName(
	label: string | null | undefined,
	maxLength: number,
	fallback = 'Unnamed bot'
): { full: string; display: string } {
	const full = label?.trim() || fallback;
	return { full, display: truncateName(full, maxLength) };
}
